import React, {useEffect} from 'react'
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import StorageService from 'services/StorageService/';

export default function(ComposedComponent) {

    const privatePath = (props) => {

        const location = useLocation();

        useEffect(() => {
            if(location) {
                const query = queryString.parse(location?.search);
                const _key = query?.token;

                if(_key === ComposedComponent?.token) {
                    const storagePrivate = StorageService.getSecureItem('page-private')
                    const pagePrivate = storagePrivate && typeof storagePrivate === 'object' ? storagePrivate : {};
                    pagePrivate[location.pathname] = _key;
                    StorageService.setSecureItem('page-private', pagePrivate);
                    window.location.href = location.pathname
                } else {
                    const keyStorage = StorageService.getSecureItem('page-private');
                    if(!(keyStorage && keyStorage[location.pathname]) || (keyStorage && keyStorage[location.pathname] !== ComposedComponent?.token)){
                        if(keyStorage && keyStorage[location.pathname]){
                            delete keyStorage[location.pathname]
                            StorageService.setSecureItem('page-private', keyStorage);
                        }
                        window.location.href = ('/');
                    }
                }
            }
        }, []);

        return <ComposedComponent {...props}/>
    }
    return privatePath
}